import React from "react";
import { withStyles } from "material-ui/styles";
import Button from "material-ui/Button";
import DownwardArrowIcon from "material-ui-icons/ArrowDownward";
import UpwardArrowIcon from "material-ui-icons/ArrowUpward";
import PropTypes from "prop-types";
import { grey } from "material-ui/colors";
import { SORT_BY } from "./actions/sort";

const styles = theme => ({
  root: {
    backgroundColor: theme.palette.background.paper,
    display: "flex",
    flexDirection: "row"
  },
  name: {
    flexGrow: 1,
    marginLeft: 24,
    display: "flex",
    flexDirection: "row"
  },
  blank: {
    width: 44,
    flexShrink: 0
  },
  icons: {
    width: 16,
    height: 16
  },
  borderLeft: {
    borderLeftWidth: 1,
    borderLeftColor: grey["200"],
    borderLeftStyle: "solid",
    flexShrink: 0,
    display: "flex",
    flexDirection: "row",
    justifyContent: "center"
  },
  sortButton: {
    width: 84
  },
  disabled: {
    color: "black"
  }
});

const AccountsSortBar = props => {
  const { classes, sortBy, onSortBy } = props;

  const handleSortByNamePress = () => {
    onSortBy("name");
  };

  const handleSortByDatePress = () => {
    if (sortBy === SORT_BY.DATE_DESC) {
      onSortBy("date", "asc");
    } else {
      onSortBy("date", "desc");
    }
  };

  const handleSortByStatusPress = () => {
    onSortBy("status");
  };

  const renderArrow = key => {
    if (key === "name" && sortBy === SORT_BY.NAME) {
      return <DownwardArrowIcon className={classes.icons} />;
    }

    if (key === "status" && sortBy === SORT_BY.STATUS) {
      return <DownwardArrowIcon className={classes.icons} />;
    }

    if (key === "date") {
      if (sortBy === SORT_BY.DATE_DESC) {
        return <DownwardArrowIcon className={classes.icons} />;
      } else if (sortBy === SORT_BY.DATE_ASC) {
        return <UpwardArrowIcon className={classes.icons} />;
      }
    }
  };

  const renderSingleSortButton = (isActive, label, func, buttonClass) => {
    let buttonType = "primary";
    let disabled = false;
    let className = classes.sortButton;
    if (isActive) {
      disabled = true;
      className = `${classes.sortButton} ${classes.disabled}`;
    }

    return (
      <div className={buttonClass}>
        <Button
          dense
          color={buttonType}
          disabled={disabled}
          className={className}
          onClick={func}
        >
          {label} {renderArrow(label)}
        </Button>
      </div>
    );
  };

  const renderNameButton = () => {
    const isActive = sortBy === SORT_BY.NAME;
    return renderSingleSortButton(
      isActive,
      "name",
      handleSortByNamePress,
      classes.name
    );
  };

  const renderDateButton = () => {
    return (
      <div className={classes.borderLeft}>
        <Button
          dense
          color="primary"
          className={classes.sortButton}
          onClick={handleSortByDatePress}
        >
          Date {renderArrow("date")}
        </Button>
      </div>
    );
  };

  const renderStatusButton = () => {
    const isActive = sortBy === SORT_BY.STATUS;
    return renderSingleSortButton(
      isActive,
      "status",
      handleSortByStatusPress,
      classes.borderLeft
    );
  };

  return (
    <div className={classes.root}>
      {renderNameButton()}
      {renderDateButton()}
      {renderStatusButton()}
      <div className={classes.blank}>" "</div>
    </div>
  );
};
AccountsSortBar.propTypes = {
  sortBy: PropTypes.string.isRequired,
  onSortBy: PropTypes.func.isRequired
};
export { AccountsSortBar };

export default withStyles(styles, { name: "AccountsSortBar" })(AccountsSortBar);



// WEBPACK FOOTER //
// ./src/AccountsSortBar.js